import React, { useEffect, useRef } from 'react';
import TextWithTooltip from '../../../../components/text-with-tooltip';
import SSMRadioButton from '../ssm-radio-button/ssm-radio-button';
import FormError from '../../../../components/form/error/error';
import { Desktop, Mobile } from '../../../../app-responsive';
import './isdn-inDial-tipt-service-details.css';

const IsdnInDialBsipServiceDetalis = (props) => {
  const {
    authorableContent,
    inDialServicesDetailsSitedata,
    siteId,
    isdnInDialServiceMigrateCancelCheckList,
    isdnInDialServiceMigrateAllCheck,
    handleInDialRadioBtnSelection,
    handleDefaultInDialRadioBtnSelection,
    isdnInDialTiptServiceHasError,
  } = props;

  const {
    title,
    tiptNoteText,
    currentServicesText,
    confirmOrderText,
    migrateAllToTiptText,
    migrateToTiptText,
    cancelText,
    inDialText,
    typeTooltip,
    typeLabel,
    serviceNumberTooltip,
    serviceNumberLabel,
    numberRangesTooltip,
    numberRangesLabel,
    numberOfTrunksTooltip,
    numberOfTrunksLabel,
    actionTooltip,
    actionLabel,
  } = authorableContent;

  const prevSiteId = useRef(siteId);

  useEffect(() => {
    if (prevSiteId.current !== siteId) {
      handleDefaultInDialRadioBtnSelection();
    }
  }, [siteId, handleDefaultInDialRadioBtnSelection]);

  const serviceDetailsDataListCount = inDialServicesDetailsSitedata.length;
  const serviceDetailsTableDesktop = inDialServicesDetailsSitedata.map(item => (
    <div className="row" key={item.serviceNumber}>
      <div className="col-1 in-dial-label">
        <span>{inDialText}</span>
      </div>
      <div className="col-2">
        <span>{item.serviceNumber}</span>
      </div>
      <div className="col-3">
        {item.numberRanges.map((range, index) => (item.numberRanges.length === index + 1 ? (<span key={`range ${range}`}>{range}</span>)
          : (<span key={`range ${range}`}>{range}<br /></span>)))}
      </div>
      <div className="col-2">
        <span>{item.numberOfTrunks}</span>
      </div>
      <div className="col-4 radio-actions">
        <SSMRadioButton
          radioButtonId={`${siteId}-indial-${item.serviceNumber}-migrate`}
          radioButtonLabel={migrateToTiptText}
          radioButtonChecked={isdnInDialServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-migrate`]}
          onRadioButtonCallBackActionWithToggle={handleInDialRadioBtnSelection}
        />
        {serviceDetailsDataListCount > 1 &&
          <SSMRadioButton
            radioButtonId={`${siteId}-indial-${item.serviceNumber}-cancel`}
            radioButtonLabel={cancelText}
            radioButtonChecked={isdnInDialServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-cancel`]}
            onRadioButtonCallBackActionWithToggle={handleInDialRadioBtnSelection}
          />
        }
      </div>
    </div>
  ));

  const serviceDetailsTableMobile = inDialServicesDetailsSitedata.map(item => (
    <div className="row" key={item.serviceNumber}>
      <div className="col-6 in-dial-label">
        <TextWithTooltip
          labelText={typeLabel}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          id="isdn-in-dial-table-type-tooltip"
          toolTipText={typeTooltip}
        />
        <span>{inDialText}</span>
      </div>
      <div className="col-6">
        <TextWithTooltip
          labelText={serviceNumberLabel}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          id="isdn-in-dial-table-service-tooltip"
          toolTipText={serviceNumberTooltip}
        />
        <span>{item.serviceNumber}</span>
      </div>
      <div className="col-6">
        <TextWithTooltip
          labelText={numberRangesLabel}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          id="isdn-in-dial-table-number-tooltip"
          toolTipText={numberRangesTooltip}
        />
        {item.numberRanges.map((range, index) => (item.numberRanges.length === index + 1 ? (<span key={`range ${range}`}>{range}</span>)
          : (<span key={`range ${range}`}>{range}<br /></span>)))}
      </div>
      <div className="col-6">
        <TextWithTooltip
          labelText={numberOfTrunksLabel}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          id="isdn-in-dial-table-trunks-tooltip"
          toolTipText={numberOfTrunksTooltip}
        />
        <span>{item.numberOfTrunks}</span>
      </div>
      <div className="col-6 radio-actions">
        <SSMRadioButton
          className="radio-migrate"
          radioButtonId={`${siteId}-indial-${item.serviceNumber}-migrate`}
          radioButtonLabel={migrateToTiptText}
          radioButtonChecked={isdnInDialServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-migrate`]}
          onRadioButtonCallBackActionWithToggle={handleInDialRadioBtnSelection}
        />
      </div>
      <div className="col-6 radio-actions">
        <SSMRadioButton
          radioButtonId={`${siteId}-indial-${item.serviceNumber}-cancel`}
          radioButtonLabel={cancelText}
          radioButtonChecked={isdnInDialServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-cancel`]}
          onRadioButtonCallBackActionWithToggle={handleInDialRadioBtnSelection}
        />
      </div>
    </div>
  ));

  return (
    <div className="isdn-in-dial-tipt-service-details">
      <div className="row">
        <div className="col-12 pl-sm-0">
          <h2 className="heading">{title}</h2>
        </div>
        {isdnInDialTiptServiceHasError &&
          <div className="col-12 pl-sm-0">
            <FormError errorText={tiptNoteText} />
          </div>
        }
      </div>
      <div className="isdn-in-dial-tipt-service-table">
        <Desktop>
          <div className="row">
            <div className="col-8">
              <h2 className="heading">{currentServicesText}</h2>
            </div>
            <div className="col-4">
              <h2 className="heading">{confirmOrderText}</h2>
            </div>
          </div>
          <div className="row table-labels">
            <div className="col-1">
              <TextWithTooltip
                labelText={typeLabel}
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="isdn-in-dial-table-type-tooltip"
                toolTipText={typeTooltip}
              />
            </div>
            <div className="col-2">
              <TextWithTooltip
                labelText={serviceNumberLabel}
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="isdn-in-dial-table-service-tooltip"
                toolTipText={serviceNumberTooltip}
              />
            </div>
            <div className="col-3">
              <TextWithTooltip
                labelText={numberRangesLabel}
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="isdn-in-dial-table-number-tooltip"
                toolTipText={numberRangesTooltip}
              />
            </div>
            <div className="col-2">
              <TextWithTooltip
                labelText={numberOfTrunksLabel}
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="isdn-in-dial-table-trunk-tooltip"
                toolTipText={numberOfTrunksTooltip}
              />
            </div>
            <div className="col-4">
              <TextWithTooltip
                labelText={actionLabel}
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="isdn-in-dial-table-action-tooltip"
                toolTipText={actionTooltip}
              />
              <SSMRadioButton
                radioButtonId={`${siteId}-indial-migrateAll`}
                radioButtonLabel={migrateAllToTiptText}
                radioButtonChecked={isdnInDialServiceMigrateAllCheck}
                onRadioButtonCallBackActionWithToggle={handleInDialRadioBtnSelection}
              />
            </div>
          </div>
          {serviceDetailsTableDesktop}
        </Desktop>
        <Mobile>
          <div className="row">
            <div className="col-6">
              <SSMRadioButton
                radioButtonId={`${siteId}-indial-migrateAll`}
                radioButtonLabel={migrateAllToTiptText}
                radioButtonChecked={isdnInDialServiceMigrateAllCheck}
                onRadioButtonCallBackActionWithToggle={handleInDialRadioBtnSelection}
              />
            </div>
          </div>
          {serviceDetailsTableMobile}
        </Mobile>
      </div>
    </div>
  );
};
export default IsdnInDialBsipServiceDetalis;
